import React from "react"
import _ from "lodash"
import { cn } from "lib/utils" 
import { Plus, Trash2, Search, Copy } from "lucide-react"


function GridDataRowAction({ item, action, clickFn }:{ item:any; action:string; clickFn:any }){
  if( action === "edit" ){
    return ( <Copy className="size-5 cursor-pointer stroke-1" onClick={() => clickFn(item)} />)
  }
  if( action === "delete" ){
    return ( <Trash2 className="size-5 cursor-pointer stroke-1" onClick={() => clickFn(item)} />)
  }
  if( action === "clone" ){
    return ( <Copy className="size-5 cursor-pointer stroke-1" onClick={() => clickFn(item)} />)
  }
  if( action === "search" ){
    return ( <Search className="size-5 cursor-pointer stroke-1" onClick={() => clickFn(item)} />)
  }
  return <></>
}


export default function GridTableRow({
  item,
  columns=[],
  isSelectedFn=() => false,
  rowClickFn=()=>{},
  actions=[],
  className=""
}:{
  item:any
  columns?:any[]
  isSelectedFn?:any
  rowClickFn?:any
  actions?:any[]
  className?:string
}){

  return (
    <div
      className="w-full hover:bg-teal-900/20 col-span-24 grid grid-cols-24 pb-2 border-b border-solid border-slate-700 cursor-pointer"
    >
      { columns.map( (col:any, idx:number) => (
        <div 
          key={idx} 
          className={cn(
            "pt-1 pb-0 flex justify-start items-center", 
            col.className,
            isSelectedFn(item) === true ? "bg-teal-900/20" : "bg-transparent",
          )}
        >
          { col.name !== "[actions]" ? (
            <span onClick={() => rowClickFn(item)}>{_.get(item, col.dataprop)}</span>
          ) : (
            <div className={cn("pt-1 pb-0 flex justify-end items-center gap-3", col.className)}>
              { actions.map( (action:any, idx:number) => (
                <GridDataRowAction key={idx} item={item} action={action.name} clickFn={action.clickFn} />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}